import Vue from 'vue'
import Vuex from 'vuex'
import context from './Modules/context/index'
import theme from './Modules/theme'
import config from './Modules/configPageSpecific'
import { analyticsMiddleware } from 'vue-analytics'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const defaultPlugins = [ analyticsMiddleware ]

export default new Vuex.Store({
  modules: {
    context, // Cashier specific
    theme, // Theme specific
    config // Specific for this config page
  },
  strict: debug,
  plugins: debug ? [ ...defaultPlugins, createLogger() ] : defaultPlugins
})
